import { DriverStatus, DriverStatusLabels } from '../enums';
import { SelectInputOption } from '@/components/inputs/SelectInput';

export const driverStatusOptions: SelectInputOption[] = [
  { label: 'Todos', value: '' },
  { label: DriverStatusLabels[DriverStatus.PENDING], value: DriverStatus.PENDING },
  { label: DriverStatusLabels[DriverStatus.ACTIVE], value: DriverStatus.ACTIVE },
  { label: DriverStatusLabels[DriverStatus.INACTIVE], value: DriverStatus.INACTIVE },
  { label: DriverStatusLabels[DriverStatus.DELETED], value: DriverStatus.DELETED },
];
